import { render, staticRenderFns } from "./wsMsg.vue?vue&type=template&id=ae04b602"
import script from "./wsMsg.vue?vue&type=script&lang=js"
export * from "./wsMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports